import React, { useEffect, useState } from 'react'
import UserProfileDropdown from '../../../components/UserProfile/UserProfile'
import Sidebar from '../../../components/Sidebar/Sidebar'
import SeedsLogo from "../../../assets/images/SeedsLogo.png"
import "./AnalyticsDashboard.css"
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { getAnalyticsViews } from '../../../redux/AnalyticsReducer/action'
import ComponentView from '../../../components/ComponentView/ComponentView'

const clientID = process.env.REACT_APP_APPSMITH_CLIENT_ID;

const AnalyticsDashboard = () => {

  const { analyticsViews } = useSelector((store) => {
    return {
        analyticsViews: store.AnalyticsReducer.analyticsViews
    }
  }, []);

  const [analyticsFilters, setAnalyticsFilters] = useState({
      display_name: ''
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getAnalyticsViews(clientID, "ANALYTICS", analyticsFilters));
  }, [dispatch, analyticsFilters]);

  return (
    <div className="applicationsDashboardContainer">
      <div className="applicationsDashboard">
        <Sidebar />

        <div className="dashboardMainContent">
          <div className="contentHeader">
            <div className="userLogo">
              <img src={SeedsLogo} alt="logo" className="SeedsLogo" />
            </div>
            <div className="headerRightPanel">
              <UserProfileDropdown />
            </div>
          </div>

          <div className='pageContentWrapper'>
            <div className='stickyHeaderContainer'>
              <div className='pageHeaderSection'>
                <div className='pageActions'>
                  <h2>Analytics Dashboard</h2>
                </div>
              </div>
            </div>

            <div className='analytics-views-container'>
              {
                analyticsViews?.map((view) => {
                  return (
                    <div className='analytics-single-view'>
                      <ComponentView key={view.view_id} view={view} />
                    </div>
                  )
                })
              }
            </div>
          </div>

        </div>
      </div>
    </div>
  )
}

export default AnalyticsDashboard